export function use2DigitDateFormatter() {
  function formatDate(dateString: string | null | undefined, locale: string): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return '';
    }

    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
    };

    return new Intl.DateTimeFormat(locale, options).format(date);
  }

  return {
    formatDate,
  };
}
